import FeaturePage from "../../components/FeaturePage";
import { FileText, Receipt, FileBarChart, Download, Shield, Clock } from "lucide-react";

export default function CreateRecords() {
  return (
    <FeaturePage
      badge="Create Business Records"
      title="Beautiful records."
      highlight="Painless paperwork."
      subtitle="Create invoices, send receipts, record sales, and log expenses easily — and stay ahead of your competitors with Brivo Analytics."
      heroImage="https://images.unsplash.com/photo-1763718528755-4bca23f82ac3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
      heroBg="cream"
      features={[
        { icon: <FileText size={22} />, title: "Branded invoices", desc: "Professional invoices with your logo, colors, and terms — sent in seconds." },
        { icon: <Receipt size={22} />, title: "Receipts & quotes", desc: "Generate receipts and quotations that customers actually like to receive." },
        { icon: <FileBarChart size={22} />, title: "Sales records", desc: "Every sale logged automatically. Search, filter, export at any time." },
        { icon: <Download size={22} />, title: "Export to anything", desc: "PDF, Excel, CSV, QuickBooks, Xero — your accountant will love you." },
        { icon: <Shield size={22} />, title: "Tax-compliant", desc: "VAT, GST, sales tax handled correctly with auto-generated tax reports." },
        { icon: <Clock size={22} />, title: "Recurring invoices", desc: "Set it once, get paid forever. Auto-send and auto-collect monthly bills." },
      ]}
      details={[
        {
          tag: "Invoicing",
          title: "Send invoices that get paid faster.",
          desc: "Beautiful, branded invoices with one-click pay buttons. Customers click, pay, done — and you get notified the moment money lands.",
          bullets: ["One-click 'Pay now' button", "Auto reminders for overdue", "Real-time payment status"],
        },
        {
          tag: "Records",
          title: "A complete paper trail without the paper.",
          desc: "Every transaction, every adjustment, every refund — searchable, filterable, exportable. Audit-ready by default.",
          bullets: ["Full transaction history", "Refund & dispute tracking", "Audit log of every change"],
        },
        {
          tag: "Analytics",
          title: "Stay ahead of your competitors with Brivo Analytics.",
          desc: "Get important data like Profit, Avg. Spend per Customer, Best Selling Product, Website clicks etc — and turn data into decisions.",
        },
      ]}
      useCases={[
        { title: "Service businesses", desc: "Time-based billing, retainers, project invoicing." },
        { title: "Retail", desc: "Receipts, refunds, returns — all logged cleanly." },
        { title: "Wholesale", desc: "Net-30/60 invoicing with auto-reminders." },
        { title: "Subscription", desc: "Recurring invoices with prorations." },
      ]}
      ctaTitle="Records that work as hard as you do."
      ctaSubtitle="Beautiful invoices, painless reports, perfect tax compliance."
      ctaAccent="pink"
    />
  );
}
